window.ccEnableDragScroll = function (container, scrollTargetSelector) {
  if (!container) return;
  var target = scrollTargetSelector ? container.querySelector(scrollTargetSelector) || container : container;
  var isDown = false;
  var startX = 0;
  var startScroll = 0;
  var moved = false;

  target.addEventListener('mousedown', function (e) {
    isDown = true;
    moved = false;
    startX = e.pageX;
    startScroll = target.scrollLeft;
    container.classList.add('is--dragging');
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    var dx = e.pageX - startX;
    if (Math.abs(dx) > 5) moved = true;
    target.scrollLeft = startScroll - dx;
  });

  window.addEventListener('mouseup', function () {
    if (!isDown) return;
    isDown = false;
    container.classList.remove('is--dragging');
  });

  target.addEventListener('click', function (e) {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }
  }, true);
};
